import { FC, SVGProps } from "react";
import Twemoji from "react-twemoji";

import { PuzzleMetadata, PuzzleType } from "sockapi/puzzle-data";

import OpenCannedHint from "images/icons/can-open.svg?react";
import CannedHint from "images/icons/can-closed.svg?react";

export enum IconType {
  CANNED_HINT = "canned_hint",
  OPEN_CANNED_HINT = "open_canned_hint",
}

// TS believes it's a string, but it's actually a react component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const iconToSvg: { [key in IconType]: any } = {
  [IconType.CANNED_HINT]: CannedHint,
  [IconType.OPEN_CANNED_HINT]: OpenCannedHint,
} as const;

export function Icon(props: { icon: IconType } & SVGProps<SVGSVGElement>) {
  const { icon, className = "", ...otherProps } = props;
  const svg = iconToSvg[icon] as FC<SVGProps<SVGSVGElement>>;
  return svg({ className: `emoji ${className}`, ...otherProps });
}

export function typeIcon(type: PuzzleType): string {
  switch (type) {
    case PuzzleType.STORY:
      return "🎬️";
    case PuzzleType.PUZZLE:
      return "🔲️";
    case PuzzleType.PIECE:
      return "🧩️";
  }
}

export function PuzzleIcon(props: { puzData: PuzzleMetadata }) {
  const { puzData } = props;
  const { isBigMeta = false, isMeta = false, type } = puzData;
  return (
    <Twemoji tag="span" options={{ folder: "svg", ext: ".svg" }}>
      {isBigMeta ? "🌏" : isMeta ? "🏝️" : typeIcon(type)}
    </Twemoji>
  );
}
